import React from "react";
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "@/components/ui/accordion";
import SectionHeading from "@/components/marketing/SectionHeading";
import Reveal from "@/components/marketing/Reveal";

export default function SectorFAQ({ faqs = [], tag = "FAQ", title = "Frequently Asked Questions" }) {
  return (
    <section className="py-7 sm:py-9 lg:py-12 bg-canvas">
      <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8">
        <Reveal>
        <SectionHeading tag={tag} title={title} />
        </Reveal>
        <Reveal variant="card">
        <Accordion type="single" collapsible>
          {faqs.map((faq, i) => (
            <AccordionItem key={i} value={`faq-${i}`} className="border-border">
              <AccordionTrigger className="text-bone hover:text-cobalt text-left font-heading text-base py-5">
                {faq.q}
              </AccordionTrigger>
              <AccordionContent className="text-steel text-sm leading-relaxed pb-5">
                {faq.a}
              </AccordionContent>
            </AccordionItem>
          ))}
        </Accordion>
        </Reveal>
      </div>
    </section>
  );
}